import highlights from '@/mixins/search/highlights'

export default {
  mixins: [highlights],
  props: {
    highlights: {
      type: Object,
      required: true
    },
    data: {
      type: Object,
      required: true
    },
    index: {
      type: String,
      required: true
    },
    highlightsLoading: {
      type: Boolean,
      required: true
    },
    link: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  data () {
    return {
      prefixMedicalCondition: '<span class="t-500">Medical Condition: </span>',
      prefixPrimaryObjective: '<span class="t-500">Primary Objective: </span>',
      prefixSecondaryObjective: '<span class="t-500">Secondary Objective: </span>',
      prefixOtherObjective: '<span class="t-500">Other Objective: </span>'
    }
  },
  computed: {
    title () {
      return this.highlights && this.highlights.full_title ? this.highlights.full_title[0] : this.data.full_title
    },
    description () {
      if (!this.isEmpty(this.highlights.primary_objective)) return `${this.prefixPrimaryObjective} ${this.highlights.primary_objective}`
      if (!this.isEmpty(this.highlights.secondary_objective)) return `${this.prefixSecondaryObjective} ${this.highlights.secondary_objective}`
      if (!this.isEmpty(this.highlights.other_objective)) return `${this.prefixOtherObjective} ${this.highlights.other_objective}`
      if (!this.isEmpty(this.highlights.medical_condition)) return `${this.prefixMedicalCondition} ${this.highlights.medical_condition}`
      if (!this.isEmpty(this.data.primary_objective)) return `${this.prefixPrimaryObjective} ${this.data.primary_objective}`
      if (!this.isEmpty(this.data.secondary_objective)) return `${this.prefixSecondaryObjective} ${this.data.secondary_objective}`
      if (!this.isEmpty(this.data.other_objective)) return `${this.prefixOtherObjective} ${this.data.other_objective}`
      return this.data.medical_condition ? `${this.prefixMedicalCondition} ${this.data.medical_condition}` : ''
    },
    status () {
      return this.data.status ? this.data.status : ''
    },
    phases () {
      return !this.isEmpty(this.data.phases) ? this.data.phases : []
    },
    locations () {
      if (this.data && !this.isEmpty(this.data.locations)) {
        return this.data.locations.filter(location => location.country)
      }
    },
    sponsors () {
      return !this.isEmpty(this.data.sponsors) ? this.data.sponsors : []
    },
    studyType () {
      return this.data.study_type ? this.data.study_type : ''
    },
    diseases () {
      return !this.isEmpty(this.data.diseases) ? this.data.diseases : []
    },
    interventions () {
      return !this.isEmpty(this.data.interventions) ? this.data.interventions : []
    }
  }
}
